import { useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"

export default function AuthCallbackPage() {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Exchange code for session (PKCE flow)
        const { data, error } = await supabaseClient.auth.getSession()
        if (error) {
          console.error("Auth callback error:", error)
          navigate("/auth/login")
          return
        }
        // Get the intended destination from state, default to feed
        const from = (location.state as any)?.from?.pathname || "/feed"
        navigate(data.session ? from : "/auth/login", { replace: true })
      } catch (e) {
        console.error("Callback exception:", e)
        navigate("/auth/login")
      }
    }
    handleCallback()
  }, [])

  return (
    <div style={{ minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)" }}>
      <div style={{ textAlign: "center" }}>
        <svg className="w-8 h-8 animate-spin mx-auto mb-3" viewBox="0 0 24 24" fill="none" style={{ color: "#ff4500" }}>
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeOpacity=".25" />
          <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
        </svg>
        <p className="text-sm" style={{ color: "var(--text2)" }}>Signing you in…</p>
      </div>
    </div>
  )
}
